import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";

const allTypes = ["PUSH-BACK", "TAKE-OFF", "LANDING", "ON-BLOCKS", "SUMMARY"];

const AircraftMovementCaptureValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";


  if (!error && !record.flightNumber) {
    error = true;
    errorMessage = "'Flight' number is required";
  }
  if (!error && !record.originAirportCodeIata) {
    error = true;
    errorMessage = "'Origin' airport is required";
  }
  if (!error && !record.destinationAirportCodeIata) {
    error = true;
    errorMessage = "'Destination' airport is required";
  }
  const pushback = moment(record.offBlocksTimeUTC);
  if (!error && !pushback.isValid()) {
    error = true;
    errorMessage = "Confirm 'Pushback' date by entering or selecting a valid date";
  }
  if (!error && pushback.isValid() && pushback.format("HH:mm") === "00:00") {
    error = true;
    errorMessage = "'Pushback' time is required";
  }
  if (!error && pushback.isAfter(moment())){
    error = true;
    errorMessage = "'Pushback' times may not be in the future";
  }
  const takeoff = moment(record.takeOffTimeUTC);
  if (allTypes.indexOf(record.movementType) > 0) {
    if (!error && !takeoff.isValid()) {
      error = true;
      errorMessage = "Confirm 'Take-off' date by entering or selecting a valid date";
    }
    if (!error && takeoff.isAfter(moment())){
      error = true;
      errorMessage = "'Takeoff' times may not be in the future";
    }
    if (!error && takeoff.isValid() && takeoff.format("HH:mm") === "00:00") {
      error = true;
      errorMessage = "'Takeoff' time is required";
    }
    if (!error && takeoff.isAfter(moment())){
      error = true;
      errorMessage = "'Takeoff' times may not be in the future";
    }
    if (!error && takeoff.isSameOrBefore(pushback)) {
      error = true;
      errorMessage = "'Takeoff' date and time must be after 'Pushback' date and time";
    }
    const eta = moment(record.etaUTC);
    if (!error && !eta.isValid()) {
      error = true;
      errorMessage = "Confirm 'ETA' date by entering or selecting a valid date";
    }
    if (!error && eta.isValid() && eta.format("HH:mm") === "00:00") {
      error = true;
      errorMessage = "'ETA' time is required";
    }
    if (!error && eta.isSameOrBefore(takeoff)) {
      error = true;
      errorMessage = "'ETA' date and time must be after 'Takeoff' date and time";
    }
  }
  const landing = moment(record.landingTimeUTC);
  if (allTypes.indexOf(record.movementType) > 1) {
    if (!error && !landing.isValid()) {
      error = true;
      errorMessage = "Confirm 'Landing' date by entering or selecting a valid date";
    }
    if (!error && landing.isValid() && landing.format("HH:mm") === "00:00") {
      error = true;
      errorMessage = "'Landing' time is required";
    }
    if (!error && landing.isAfter(moment())){
      error = true;
      errorMessage = "'Landing' times may not be in the future";
    }
    if (!error && landing.isSameOrBefore(takeoff)) {
      error = true;
      errorMessage = "'Landing' date and time must be after 'Takeoff' date and time";
    }
  }
  const onBlocks = moment(record.onBlocksTimeUTC);
  if (allTypes.indexOf(record.movementType) > 2) {
    if (!error && !onBlocks.isValid()) {
      error = true;
      errorMessage = "Confirm 'Blocks-on' date by entering or selecting a valid date";
    }
    if (!error && onBlocks.isValid() && onBlocks.format("HH:mm") === "00:00") {
      error = true;
      errorMessage = "'Blocks-on' time is required";
    }
    if (!error && onBlocks.isAfter(moment())){
      error = true;
      errorMessage = "'Blocks-on' times may not be in the future";
    }
    if (!error && onBlocks.isSameOrBefore(landing)) {
      error = true;
      errorMessage = "'Blocks-on' date and time must be after 'Landing' date and time";
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default AircraftMovementCaptureValidator;
